import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

import { PageInfo, ProjectInfo } from '@blaze-shared/api-contracts-domain';
import { BlazePickerComponent, PickerOption } from '@blaze-shared/shared-ui';

@Component({
  imports: [BlazePickerComponent, MatIconModule],
  selector: 'blaze-action-bar-nav',
  templateUrl: './action-bar-nav.component.html',
  styleUrls: ['./action-bar-nav.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActionBarNavComponent {
  readonly pageId = input<string | null | undefined>(null);
  readonly pages = input<PageInfo[]>([]);
  readonly currentProject = input<ProjectInfo | null | undefined>(null);
  readonly projectGroupName = input<string>('');
  readonly projects = input<ProjectInfo[]>([]);
  readonly areProjectsLoading = input<boolean | undefined | null>(false);

  readonly navigateToPage = output<PageInfo>();
  readonly navigateToProject = output<ProjectInfo>();

  protected readonly currentPage = computed(
    () => this.pages().find((p) => p.id === this.pageId()) ?? null,
  );
  protected readonly hasPageOptions = computed(() => this.pages().length > 0);
  protected readonly hasProjectOptions = computed(() => this.projects().length > 0);
  protected readonly pagePickerOptions = computed<PickerOption<PageInfo>[]>(() =>
    this.pages().map((p) => ({ label: p.name, value: p.id, dataBag: p })),
  );
  protected readonly projectPickerOptions = computed<PickerOption<ProjectInfo>[]>(() =>
    this.projects().map((p) => ({ label: p.name, value: p.id, dataBag: p })),
  );

  protected navigateToCurrentPage(): void {
    const currentPage = this.currentPage();
    if (!currentPage) {
      return;
    }
    this.navigateToPage.emit(currentPage);
  }

  protected navigateToCurrentProject(): void {
    const projectInfo = this.currentProject();
    if (!projectInfo) {
      return;
    }
    this.navigateToProject.emit(projectInfo);
  }

  protected pageClick(event: PickerOption<PageInfo>): void {
    if (!event.dataBag) {
      return;
    }
    this.navigateToPage.emit(event.dataBag);
  }

  protected projectClick(event: PickerOption<ProjectInfo>): void {
    if (!event.dataBag) {
      return;
    }
    this.navigateToProject.emit(event.dataBag);
  }
}
